import { c as _c } from "react-compiler-runtime";
import { useMemo } from 'react';
import { TourCompletionStatus } from '../constants/TourCompletionStatus';
import { shouldHideOnboardingForSelenium } from '../utils/env';
import onboardingTourBlockListedObjectTypes from '../constants/onboardingTourBlockListedObjectTypes';
import { getIsWorkflowActionsUrl } from 'collaboration-sidebar/utils/urls';
import useOverrideTourContent from './useOverrideTourContent';
import useTourStatus from './useTourStatus';
export default function useOnboardingTour(t0) {
  "use memo";

  const $ = _c(4);
  const {
    tourId,
    objectType,
    featureIsVisible: t1
  } = t0;
  const featureIsVisible = t1 === undefined ? true : t1;
  const isWorkflowActionsUrl = getIsWorkflowActionsUrl();
  let t2;
  if ($[0] !== objectType) {
    t2 = {
      objectType
    };
    $[0] = objectType;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  useOverrideTourContent(t2);
  let t3;
  if ($[2] !== tourId) {
    t3 = {
      tourId
    };
    $[2] = tourId;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    tourStatus,
    loading
  } = useTourStatus(t3);
  let t4;
  bb0: {
    if (!objectType) {
      t4 = false;
      break bb0;
    }
    const tourBlockList = onboardingTourBlockListedObjectTypes[tourId];
    if (tourBlockList.includes(objectType)) {
      t4 = false;
      break bb0;
    }
    if (isWorkflowActionsUrl) {
      t4 = false;
      break bb0;
    }
    if (!featureIsVisible || shouldHideOnboardingForSelenium()) {
      t4 = false;
      break bb0;
    }
    if (loading) {
      t4 = false;
      break bb0;
    }
    const searchParams = new URLSearchParams(document.location.search);
    const onboardingTourId = searchParams.get("onboardingTourId");
    const isTourInQueryParam = onboardingTourId === tourId;
    t4 = isTourInQueryParam || tourStatus.status !== TourCompletionStatus.COMPLETE;
  }
  const showTour = t4;
  return showTour;
}